var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"links"},[_vm._l((_vm.links),function(l,idx){return [_c('a',{key:idx,attrs:{"href":l.link,"target":"_blank"}},[_vm._v(_vm._s(l.description))]),(idx < _vm.links.length -1 )?[_vm._v(" | ")]:_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }